import { Decodable } from './_decodable';
class Vehicle extends Decodable {
    id: number
    plate: string
    createdAt: Date
    updatedAt: Date

    protected _map = {
        createdAt: e => this.parseDate(e),
        updatedAt: e => this.parseDate(e),
    }
}

export {
    Vehicle
}